import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.less';
import App from './App';

const container = document.getElementById('root');
const baseRoot = createRoot(container!);
baseRoot.render(<App />);

